import { createContext, useContext } from 'react';

const InterveneSocketContext = createContext(null);

export function InterveneSocketContextProvider({ children, value }) {
  return (
    <InterveneSocketContext.Provider value={value}>
      {children}
    </InterveneSocketContext.Provider>
  );
}

export function useInterveneSocketContext() {
  const context = useContext(InterveneSocketContext);
  if (!context) {
    throw new Error('useInterveneSocketContext must be used within InterveneSocketProvider');
  }
  return context;
}
